import React from 'react';
import './NavBar.css'; // Make sure to create a NavBar.css file in the same directory

const NavBar = () => {
    return (
        <nav className="navbar">
            <div className="navbar-brand">Kann Portfolio Optimizer</div>
            <ul className="nav-links">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/contact">Contact</a></li>
            </ul>
        </nav>
    );
};

export default NavBar;
